<div class="offcanvas offcanvas-end show" (hidden.bs.offcanvas)="handleOffcanvasClose()" tabindex="-1" id="openCallForm"
	aria-labelledby="offcanvasRightLabel" aria-modal="true" role="dialog" style="visibility: visible;">
	<div class="offcanvas-header">
		<h5 id="offcanvasRightLabel">Fill mandatory details</h5>
		<button type="button" (click)="handleOffcanvasClose()" class="btn-close text-reset" data-bs-dismiss="offcanvas"
			aria-label="Close">
			<!-- <img src="/assets/images/new-cross.svg" alt=""> -->
		</button>
	</div>
	<div class="offcanvas-body">
		<div class="row">
			<div class="col-lg-12 col-md-12 col-sm-12 ">
				<form [formGroup]="userChatIntakeForm" (ngSubmit)="onSubmit()">
					<div class="card ">
						<div class="row justify-content-center">
							<div class="col-lg-12 col-md-12 col-sm-12 mb-3">
								<label for="name" class="form-label">Your name<span class="text-danger">*</span></label>
								<input type="text" class="form-control" id="name" formControlName="name" placeholder="Your Name">
								<div id="f_name" class="form-text"> </div>
							</div>

							<div class="col-lg-12 col-md-12 col-sm-12 mb-3  ">
								<label for="" class="mb-2">Mobile No.(You will get call on this no.)</label>
								<ngx-intl-tel-input class="custom background-unset"
									[preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
									customPlaceholder="Mobile number" [enablePlaceholder]="true" [searchCountryFlag]="true"
									[searchCountryField]="[
														SearchCountryField.Iso2,
														SearchCountryField.Name
													]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="10"
									[phoneValidation]="false" [numberFormat]="PhoneNumberFormat.National" name="mobile"
									formControlName="customerMobile">
								</ngx-intl-tel-input>
							</div>

							<div class="col-lg-12 col-md-12 col-sm-12 mb-3">
								<label for="gender" class="form-label">Gender:<span class="text-danger">*</span></label>
								<select name="gender" formControlName="gender" class="form-control" id="">
									<option value="">Select Gender</option>
									<option value="male">Male</option>
									<option value="female">Female</option>
								</select>
							</div>
						

							<div class="col-lg-12 col-md-12 col-sm-12 mb-12">
								<label for="MaritalStatus" class="form-label">Enter Question
								</label>
								<input type="text" class="form-control" id="userComment" formControlName="userComment"
									placeholder="Write your query">
								<div id="marital" class="form-text"> </div>
							</div>


						</div>
					</div>
					<div class="row btn-popup-submit">
						<div class="col-lg-12 col-md-12 col-sm-12 ">
							<button class="btn strtchat"
								[disabled]="!userChatIntakeForm.valid || (this.userChatIntakeForm.value?.customerMobile?.number && this.userChatIntakeForm.value?.customerMobile?.number?.length!=10)">Submit</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>